var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#order_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001B3A",
    d: "M13.458 10.833c.625 0 1.175-.341 1.459-.858L17.9 4.567a.83.83 0 0 0-.725-1.234H4.842l-.784-1.666H1.333v1.666H3l3 6.325-1.125 2.034c-.608 1.116.192 2.475 1.458 2.475h10V12.5h-10l.917-1.667zM5.633 5h10.125l-2.3 4.167h-5.85zm.7 10c-.916 0-1.658.75-1.658 1.667 0 .916.742 1.666 1.658 1.666.917 0 1.667-.75 1.667-1.666C8 15.75 7.25 15 6.333 15m8.334 0c-.917 0-1.659.75-1.659 1.667 0 .916.742 1.666 1.659 1.666.916 0 1.666-.75 1.666-1.666 0-.917-.75-1.667-1.666-1.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "order_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgOrder;